import moment from 'moment';

export default function parseFromET(dateStr) {
  const formattedTime = moment(dateStr).format('YYYY-MM-DD HH:mm');
  const actionTime = moment.tz(formattedTime, 'America/New_York');
  return actionTime.clone().tz(Intl.DateTimeFormat().resolvedOptions().timeZone);
}
